module.exports = __webpack_public_path__ + "ff57c15e8b1edb7a45aa962a0419b35f.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/getfpv.png
 ** module id = 195
 ** module chunks = 0
 **/